"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FieldsSetupFlowController_1 = __importDefault(require("../../modules/controllers/FieldsSetupFlowController"));
let GisFilesBlockAssigment = class GisFilesBlockAssigment extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.filesSummaryStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.fieldNameMetadata = '';
        this.farmNameMetadata = '';
        this.loadingMetadata = false;
    }
    setFieldNameMetadata(value) {
        this.fieldNameMetadata = value;
    }
    setFarmNameMetadata(value) {
        this.farmNameMetadata = value;
    }
    get blockOptions() {
        const files = this.STEP_CONTROLLER.data.files;
        const columnSets = files.map((file) => new Set(file.metadata.map(meta => meta.columnName)));
        const commonColumns = columnSets.reduce((acc, set) => new Set([...acc].filter(column => set.has(column))));
        return Array.from(commonColumns).map(columnName => {
            var _a;
            const fileWithColumn = files.find(file => file.metadata.some(meta => meta.columnName === columnName));
            const columnValue = (_a = fileWithColumn === null || fileWithColumn === void 0 ? void 0 : fileWithColumn.metadata.find(meta => meta.columnName === columnName)) === null || _a === void 0 ? void 0 : _a.columnValue;
            return {
                name: columnName,
                value: columnValue
            };
        });
    }
    setMetadata() {
        this.loadingMetadata = true;
        if (!this.fieldNameMetadata && !this.farmNameMetadata) {
            console.warn("No se seleccionaron columnas válidas para campo o finca");
            this.loadingMetadata = false;
            return;
        }
        const fileMetadataMap = new Map();
        this.STEP_CONTROLLER.data.files.forEach(file => {
            fileMetadataMap.set(file.name, file);
        });
        this.STEP_CONTROLLER.data.fieldsProcessed.forEach((field) => {
            const fieldMeta = field.metadata.find(meta => meta.columnName === this.fieldNameMetadata);
            const farmMeta = field.metadata.find(meta => meta.columnName === this.farmNameMetadata);
            if (farmMeta === null || farmMeta === void 0 ? void 0 : farmMeta.columnValue)
                field.setFarmName(farmMeta.columnValue.toString());
            if (fieldMeta === null || fieldMeta === void 0 ? void 0 : fieldMeta.columnValue)
                field.setName(fieldMeta.columnValue.toString());
        });
        this.NEXT_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.fieldsProcessed);
        this.MAIN_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
        setTimeout(() => {
            this.loadingMetadata = false;
        }, 10000);
    }
    closeModal() {
        this.$emit('closeModal');
    }
};
GisFilesBlockAssigment = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { Button: bmk_ui_framework_1.Button, Modal: bmk_ui_framework_1.Modal, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon, Select: bmk_ui_framework_1.Select } })
], GisFilesBlockAssigment);
exports.default = GisFilesBlockAssigment;
